import React from 'react';
import {
  ConfirmPropertyItemFileUploadPiclib,
  FileUploadProperty,
} from 'shared';
import { useFileUploadItem } from 'store';

type Props = {
  property: FileUploadProperty;
  color: string;
};

export const FileUpload: React.FC<Props> = ({ property, color }) => {
  const { inputFormat, propertyId } = property;
  const { subjectId } = inputFormat;
  const fileUploadItem = useFileUploadItem(subjectId);

  return (
    <ConfirmPropertyItemFileUploadPiclib
      propertyId={propertyId}
      color={color}
      thumbnail={fileUploadItem?.thumbnail}
    />
  );
};
